import React, { useEffect, useState } from 'react';
import { useRoleContentParser } from './useHeaderContentParser';
import {
  ButtonCont,
  DetailsCont,
  MediaCont,
  MediaSection,
  RoleButton,
  RoleButtonSubmitted,
  RoleDetailsCont,
} from './RoleDetails.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { CircularProgress, useTheme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { NoteCont, Wrapper, Label } from '../RoleItem.styles';
import RoleContentLoader from './RoleDetailsLoader';
import MediaItem from '../../MediaItems/MediaItem';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import { customSort } from 'shared/interfaces/utils/IMediaFileType';
import LinkItem from 'shared/components/LinkItem/LinkItem';
import LinkItemLite from 'shared/components/LinkItem/LinkItemLite';
import { IMediumAttributes } from 'shared/interfaces/IMedium';

interface Props {
  roleId: string;
  projectId: string;
  roleDescription: string;
  workingNote: string;
  companyName: string;
  roleName: string;
  type: 'new' | 'submitted' | 'not_interested';
  notYetSubmitted?: boolean;
}

type TApplicationStatus = 'ready' | 'applying' | 'applied';

const RoleDetails: React.FC<Props> = ({
  roleId,
  roleDescription,
  workingNote,
  projectId,
  companyName,
  roleName,
  type,
  notYetSubmitted,
}) => {
  const isDark = useTheme().palette.type === 'dark';
  const { roleMedia, wardrobeNote, auditionNote, roleLoading, links } = useRoleContentParser(roleId);
  const applyToRole = useContextSelector(OpportunitiesContext, (state) => state.applyToRole);
  const appliedRoles = useContextSelector(OpportunitiesContext, (state) => state.appliedRoles);
  const applicationData = useContextSelector(OpportunitiesContext, (state) => state.applicationData);

  const [applicationStatus, setApplicationStatus] = useState<TApplicationStatus>('ready');

  const handleApply = () => {
    // setApplicationStatus('applying');
    // applyToRole(roleId, projectId, companyName, roleName).then((res) => {
    //   setApplicationStatus(res ? 'applied' : 'ready');
    // });
    applyToRole(roleId, projectId, companyName, roleName);
  };

  // useEffect(() => {
  //   console.log('RoleContent Rendered', roleId);
  // });

  useEffect(() => {
    if (applicationData.casting_role_id === roleId) {
      setApplicationStatus('applying');
    } else {
      setApplicationStatus('ready');
    }
    if (appliedRoles.includes(roleId)) {
      setApplicationStatus('applied');
    }
  }, [appliedRoles, applicationData.casting_role_id, roleId]);

  if (roleLoading) return <RoleContentLoader />;
  return (
    <RoleDetailsCont>
      <MediaSection>
        <Label>Reference Media: </Label>
        <MediaCont>
          {/* {roleMedia.map((m) => (
            <MediaItem key={m.id} src={m.attachment} type={m.medium.file_type} />
          ))} */}
          {/* sort roleMedia by m.type */}
          {(roleMedia as IMediumAttributes[])
            // .sort((a, b) => a.medium.file_type.localeCompare(b.medium.file_type))
            .sort(customSort)
            .map((m) => (
              <MediaItem key={m.id} file={m} />
            ))}
          {links.length > 0 ? links.map((link, idx) => <LinkItemLite key={idx} url={link} />) : <React.Fragment />}
        </MediaCont>
      </MediaSection>

      <DetailsCont>
        <NoteCont>
          <Wrapper rolecontent={1}>
            <Label>Description: </Label>
            <CustomTypography>{roleDescription}</CustomTypography>
          </Wrapper>

          <Wrapper rolecontent={1}>
            <Label>Working Note:</Label>
            <CustomTypography>{workingNote}</CustomTypography>
          </Wrapper>
        </NoteCont>
        <NoteCont
          style={{
            borderTop: `1px solid ${isDark ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
            paddingTop: 10,
          }}
        >
          <Wrapper rolecontent={1}>
            <Label>Audition Note: </Label>
            <CustomTypography>{auditionNote}</CustomTypography>
          </Wrapper>

          <Wrapper rolecontent={1}>
            <Label>Wardrobe Note:</Label>
            <CustomTypography>{wardrobeNote}</CustomTypography>
          </Wrapper>
        </NoteCont>
        <ButtonCont>
          {/* TODO: Phase 2 */}
          {/* <RoleButton variant="outlined" color="primary">
            Edit Profile
          </RoleButton> */}
          {Boolean(applicationStatus === 'applied') || (type === 'submitted' && !notYetSubmitted) ? (
            <RoleButtonSubmitted>Submitted</RoleButtonSubmitted>
          ) : (
            <RoleButton
              disabled={applicationStatus === 'applying'}
              style={{ color: 'white' }}
              onClick={handleApply}
              variant="contained"
              color="primary"
            >
              {applicationStatus === 'applying' ? <CircularProgress size={20} /> : 'Submit'}
            </RoleButton>
          )}
        </ButtonCont>
      </DetailsCont>
    </RoleDetailsCont>
  );
};

export default React.memo(RoleDetails);
